import React, { useEffect } from "react";
import { Box, makeStyles } from "@material-ui/core";
import StandardPageHelmet from "../../../seo/components/StandardPageHelmet";
import useSEO from "../../../seo/use-seo";
import PublicLayout from "../../../layouts/PublicLayout";
import {
    VaultHeroSection,
    VaultPremiumSection,
    VaultFeaturedSection,
    VaultMembershipSection,
    VaultPrivacySection,
    VaultCTASection
} from "./TheVault";

import vaultHeroImg from "../../Main/Landing/images/Vault/hero_img.png";

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: "Roboto, Arial, sans-serif",
        backgroundColor: '#0a0a0a',
        color: '#ffffff',
        minHeight: '100vh',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    }
}));

export default function TheVaultPage() {
    const classes = useStyles();
    const seo = useSEO("home", {
        title: "The Vault | Exclusive Benefits & Premium Experiences | SugarCribs",
        description: "Unlock The Vault at SugarCribs. Discover elite creator benefits, exclusive PPV releases, private creator feeds, total discretion, and premium memberships."
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <PublicLayout>
            <StandardPageHelmet 
                seo={seo} 
                ogImageUrl={vaultHeroImg}
            />
            <Box className={classes.root}>
                <VaultHeroSection />
                <VaultPremiumSection />
                <VaultFeaturedSection />
                <VaultMembershipSection />
                <VaultPrivacySection />
                <VaultCTASection />
            </Box>
        </PublicLayout>
    );
}
